import React, { useState } from 'react';
import { ScrollReveal } from './ui/ScrollReveal';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Es digital?',
  a: 'Sí, recibís el acceso a todos los archivos por email al instante. Podés leerlo en tu celular, tablet o computadora, o imprimirlo si preferís el papel.'
}, {
  q: '¿Sirve para niños?',
  a: 'Absolutamente, incluimos un apartado especial con dosis infantiles seguras y qué plantas son aptas para cada edad.'
}, {
  q: '¿Consigo las plantas fácilmente?',
  a: 'Sí, todas las plantas mencionadas se consiguen en cualquier dietética de barrio o monte de Argentina a precios súper accesibles.'
}, {
  q: '¿Necesito tener un jardín?',
  a: 'No, el 90% de las plantas se pueden comprar ya secas en la dietética, o bien cultivarlas en macetas chicas en un balcón o ventana.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 bg-sage relative" data-id="element-1">
      <div className="max-w-3xl mx-auto px-4" data-id="element-2">
        <ScrollReveal data-id="element-3">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-center text-forest mb-12" data-id="element-4">
            Preguntas Frecuentes
          </h2>
        </ScrollReveal>

        <div className="space-y-4" data-id="element-5">
          {faqs.map((faq, index) => <ScrollReveal key={index} delay={index * 100} data-id="element-6">
              <div className="bg-white rounded-xl shadow-sm border border-forest/10 overflow-hidden transition-all duration-300" data-id="element-7">
                <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => toggleFaq(index)} data-id="element-8">
                  <span className="font-bold text-brown text-lg pr-4" data-id="element-9">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`w-6 h-6 text-forest transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-10" />
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-11">
                  <p className="text-brown/80 font-sans" data-id="element-12">{faq.a}</p>
                </div>
              </div>
            </ScrollReveal>)}
        </div>
      </div>
    </section>;
}